import { render, staticRenderFns } from "./class-quesbank-detail.vue?vue&type=template&id=fefb7dc8&scoped=true"
import script from "./class-quesbank-detail.vue?vue&type=script&lang=js"
export * from "./class-quesbank-detail.vue?vue&type=script&lang=js"
import style0 from "./class-quesbank-detail.vue?vue&type=style&index=0&id=fefb7dc8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fefb7dc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fefb7dc8')) {
      api.createRecord('fefb7dc8', component.options)
    } else {
      api.reload('fefb7dc8', component.options)
    }
    module.hot.accept("./class-quesbank-detail.vue?vue&type=template&id=fefb7dc8&scoped=true", function () {
      api.rerender('fefb7dc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/senate/class-quesbank-detail.vue"
export default component.exports